import { siteInfo } from '@/mocks/clCommunityData';

export default function CommunityStats() {
  const stats = [
    { value: siteInfo.members, label: '注册用户' },
    { value: siteInfo.posts, label: '帖子总数' },
    { value: siteInfo.dailyActive, label: '日活跃用户' },
    { value: siteInfo.forumCount, label: '内容板块' },
  ];

  return (
    <section className="py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              {siteInfo.name}·社区数据
            </h2>
            <p className="text-sm text-foreground-500">用数字见证CL社区的成长与活力</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-extrabold text-primary-500 mb-2">
                  {stat.value}
                </div>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}